export const initialState = () => ({
	files: []	
});

export const folders = ['brands', 'images', 'pdfs']	

export const skeleton = {
	path: '',
	mime: '',
	originalPath: ''
}

export const validation = {
	mimes: [
		'image/png',
		'image/jpeg',
		'application/pdf'
	],
	size: {
		image: 5000000,
		pdf: 10000000
	},
	dimensions: {
		min: {
			height:50,
			width:50
		},
		max: {
			height:3000,
			width:3000
		}
	}
}

export default initialState();
